"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const styleOverrides = {
  root: ({
    theme
  }) => ({
    justifyContent: 'center',
    minHeight: 'unset',
    position: 'relative',
    '&:after': {
      position: 'absolute',
      bottom: 0,
      content: '""',
      width: '100%',
      height: 3,
      backgroundColor: theme.palette.grey[200]
    }
  }),
  indicator: ({
    theme
  }) => ({
    height: 3,
    zIndex: 1,
    backgroundColor: theme.palette.text.primary
  }),
  scroller: {
    flexGrow: 0,
    zIndex: 1
  }
};
const defaultProps = {
  textColor: 'primary'
};
var _default = exports.default = {
  styleOverrides,
  defaultProps
};
//# sourceMappingURL=MuiTabs.js.map